import { DownloadUploadFromSignedUrl } from './useUpload';

export const useDownload = ({url}) => {
  const download = async (name) => {
    return await DownloadUploadFromSignedUrl.download(name,url)
  };

  return[download]

};